enum BlogPostType {
  None,
  Blog,
  Offer
}

export default BlogPostType